import { useMemo } from "react";
import { ESupportLanguageOfSupport } from "@devowl-wp/api-real-commerce";
import { __ } from "../utils/i18n.js";
/**
 * Get the allowed languages localized as object.
 */ function useSupportFormLanguage() {
    return useMemo(()=>{
        const result = {};
        Object.keys(ESupportLanguageOfSupport).forEach((key)=>{
            const value = ESupportLanguageOfSupport[key];
            let localized = key;
            switch(value){
                case ESupportLanguageOfSupport.English:
                    localized = __("English");
                    break;
                case ESupportLanguageOfSupport.German:
                    localized = __("German");
                    break;
                default:
                    break;
            }
            result[value] = {
                localized,
                key,
                value
            };
        });
        return result;
    }, []);
}
export { useSupportFormLanguage };
